import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import { Location16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

// models
import { AddressViewModel } from '../../../models/Entities/Person/Address/AddressModels';

// components
import PersonAddressFormComponent from './PersonAddress.Form.Component';
import { PersonContactList } from '../PersonContactList/PersonContactList.Component';

// functions
import * as ComponentFunctions from './PersonAddresses.List.Functions';

const addressLabel = (address: AddressViewModel): string =>
  [address.street, address.city, address.country].filter(Boolean).join(', ');

/** Ciudad, código postal y país en una línea secundaria. */
const addressPlace = (address: AddressViewModel): string =>
  [address.city, address.postalCode, address.country].filter(Boolean).join(' · ');

/** Domicilios de la persona: grupo compacto de la tarjeta de contacto, con alta, edición y baja. */
const PersonAddressesListComponent = (props: ComponentFunctions.Props) => {
  const [t] = useTranslation();
  const [isFormOpen, { setTrue: openForm, setFalse: dismissForm }] = useBoolean(false);
  const [selectedAddressId, setSelectedAddressId] = useState<number | undefined>(undefined);

  const load = () => { if (props.PersonId) props.GetAddressesByPersonId(props.PersonId); };
  useEffect(() => { load(); }, [props.PersonId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PersonContactList<AddressViewModel>
        testId="person-addresses"
        wide
        title={t('persons.addresses.list.count', { defaultValue: 'Domicilios' })}
        icon={<Location16Regular />}
        items={props.addresses}
        primary={(address) => address.street || '—'}
        secondary={(address) => addressPlace(address) || undefined}
        itemLabel={addressLabel}
        isLoading={props.isLoading}
        failOnLoading={props.failOnLoading}
        isDeleting={props.isDeleting}
        failOnDeleting={props.failOnDeleting}
        error={props.error}
        addLabel={t('persons.addresses.list.add', { defaultValue: 'Agregar domicilio' })}
        emptyText={t('persons.addresses.list.empty', { defaultValue: 'No hay domicilios registrados' })}
        loadingLabel={t('persons.addresses.list.loading', { defaultValue: 'Cargando domicilios...' })}
        loadErrorTitle={t('persons.addresses.list.error', { defaultValue: 'No fue posible obtener los domicilios' })}
        deleteTitle={t('persons.addresses.list.deleteTitle', { defaultValue: 'Eliminar domicilio' })}
        deleteText={(address) => t('persons.addresses.list.deleteText', { defaultValue: 'Se va a eliminar el domicilio {{address}}. Esta acción no se puede deshacer.', address: addressLabel(address) })}
        onAdd={() => { setSelectedAddressId(undefined); openForm(); }}
        onEdit={(address) => { setSelectedAddressId(address.id); openForm(); }}
        onDelete={(address) => props.DeleteAddress(address.id)}
        onRetry={load}
      />
      <PersonAddressFormComponent
        isOpen={isFormOpen}
        openPanel={openForm}
        dismissPanel={() => { setSelectedAddressId(undefined); dismissForm(); }}
        PersonId={props.PersonId}
        addressId={selectedAddressId}
      />
    </>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(PersonAddressesListComponent as any);
